export default {
  title: 'Application mobile',
  fields: {
    name: "Nom de l'application",
  },
  buttons: {
    save: 'Enregistrer',
  },
};
